import fp from 'lodash/fp';
import * as constants from './constants';
import * as actions from './actions';

export const INITIAL_STATE = {
    columns: constants.columns,
    loading: false,
    rows: []
};

const setLoading = fp.set('loading');
const setRows = fp.set('rows');

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_LOADING: {
            return setLoading(action.loading, state);
        }
        case actions.SET_ROWS: {
            return setRows(action.rows, state);
        }
        default:
            return state;
    }
}
